import { isIpad } from 'constants/browserDetection';
import { FeatureFlag, useFeatureFlags } from 'featureFlags';
import React, { FC, PropsWithChildren } from 'react';
import { Sheet as SheetRecord } from 'records/Sheet';
import Sheet from './Sheet';
import TileSheet from './TileSheet';

type Props = PropsWithChildren<{
  documentid: string;
  pageid: string;
  sheet?: SheetRecord;
  width?: number;
  height?: number;
  withMarkups?: boolean;
  isInteractive?: boolean;
  drawingtilescloudfronturl?: string;
  drawingmaxzoom?: number;
  drawingminzoom?: number;
  drawingtilesize?: number;
}>;

// This component creates and manages the Carnivore "Sheet" component.
const ECSSheet: FC<Props> = (props: Props) => {
  const {
    documentid,
    pageid,
    sheet,
    width,
    height,
    withMarkups,
    isInteractive,
    drawingtilescloudfronturl,
    drawingmaxzoom,
    drawingminzoom,
    drawingtilesize,
  } = props;

  const { [FeatureFlag.DrawingTiles]: isDrawingTilesEnabled } =
    useFeatureFlags();

  return drawingtilescloudfronturl &&
    isDrawingTilesEnabled &&
    drawingtilesize &&
    drawingtilesize > 0 &&
    width &&
    height &&
    !isIpad ? (
    <TileSheet
      key={pageid}
      documentid={documentid}
      pageid={pageid}
      sheet={sheet}
      withMarkups={withMarkups}
      isInteractive={isInteractive}
      drawingtilescloudfronturl={drawingtilescloudfronturl}
      drawingmaxzoom={drawingmaxzoom || 0}
      drawingminzoom={drawingminzoom || 0}
      drawingtilesize={drawingtilesize}
      width={width}
      height={height}
    />
  ) : (
    <Sheet
      key={pageid}
      documentid={documentid}
      pageid={pageid}
      sheet={sheet}
      width={width}
      height={height}
      withMarkups={withMarkups}
      isInteractive={isInteractive}
    />
  );
};

export default ECSSheet;
